module.exports = __webpack_public_path__ + "img/2015成都会.8bb0d26e.jpg";